import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import './HeaderIcon.css';
function findLinkSource(link) {
  if (link) {
    if (link.includes('google')) return {
      name: 'google plus',
      style: {
        color: '#DD4B39'
      }
    };
    if (link.includes('facebook')) return {
      name: 'facebook',
      style: {
        color: '#3b5998'
      }
    };
    if (link.includes('yelp')) return {
      name: 'yelp',
      style: {
        color: '#c41200'
      }
    };
    if (link.includes('tripadvisor')) return {
      name: 'tripadvisor',
      style: {
        color: '#00af87'
      }
    };
  }
  return {
    name: '',
    style: {}
  };
}
function renderIcon(iconProps) {
  var name = iconProps.name,
    style = iconProps.style;
  return /*#__PURE__*/React.createElement(Icon, {
    name: name,
    style: style,
    size: "small"
  });
}
var HeaderIcon = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HeaderIcon, _React$PureComponent);
  var _super = _createSuper(HeaderIcon);
  function HeaderIcon() {
    _classCallCheck(this, HeaderIcon);
    return _super.apply(this, arguments);
  }
  _createClass(HeaderIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        link = _this$props.link,
        showLink = _this$props.showLink,
        isVerticalItem = _this$props.isVerticalItem;
      var iconProps = findLinkSource(link);

      // For verticalItems we need to override the default <Header.Content /> CSS in ItemElement
      if (isVerticalItem) {
        iconProps.style = _objectSpread(_objectSpread({}, iconProps.style), {}, {
          display: 'inline-block',
          fontSize: '1em'
        });
      }
      var icon = renderIcon(iconProps);
      return link && showLink ? /*#__PURE__*/React.createElement("a", {
        href: link,
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "header-icon",
        "aria-label": iconProps.name
      }, icon)) : icon;
    }
  }]);
  return HeaderIcon;
}(React.PureComponent);
export { HeaderIcon as default };
HeaderIcon.defaultProps = {
  showLink: true,
  isVerticalItem: false
};